export default {
  path: '/match',
  name: 'Match',
  redirect: '/match/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      name: 'MatchList',
      component: () => import('@/views/match'),
      meta: { requiresAuth: true }
    },
    {
      path: 'addMatch', // 添加赛事
      name: 'AddMatch',
      component: () => import('@/views/match/addMatch'),
      meta: { requiresAuth: true }
    },
    {
      path: 'detail',
      name: 'MatchDetail',
      component: () => import('@/views/match/matchDetail'),
      meta: { requiresAuth: true }
    },

  ]
}
